
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { PaymentRequestModel } from '@/models/payment-request';
import { Order } from '@/models/order';

@Component
export default class ListOrder extends Vue {
    private eventEmit = {
        eventChangeData: 'eventChangeData'
    };

    @Prop({default: []})
    private orders!: Order[];
    @Prop({default: null})
    private paymentRequest!: PaymentRequestModel;
    private isCheckAll = false;
    
    get totalPackage() {
        return this.orders.reduce((total: number, order: any) => {
            return total + (order.numberOfPack || 0);
        }, 0);
    }

    get totalWeight() {
        return this.orders.reduce((total: number, order: any) => {
            return total + (order.weight || 0);
        }, 0);
    }

    get totalWeightByVolume() {
        return this.orders.reduce((total: number, order: any) => {
            return total + (order.weightByVolume || 0);
        }, 0);
    }

    get totalVolume() {
        return this.orders.reduce((total: number, order: any) => {
            return total + (order.volume || 0);
        }, 0);
    }

    get totalPaymentWeight() {
        return this.orders.reduce((total: number, order: any) => {
            return total + ((order.feeShipType !== 1 ? (order.feeShipType === 0 ? order.weight : order.weightByVolume) : 0) || 0);
        }, 0);
    }

    get totalPaymentVolume() {
        return this.orders.reduce((total: number, order: any) => {
            return total + ((order.feeShipType === 1 ? order.volume : 0) || 0);
        }, 0);
    }
}
